import { useQueryParams } from 'hooks';

const EMBEDDABLE_QUERY_KEY = 'embeddable';

/**
 * Returns whether the current page is rendered in Community Calendar iframe embed mode
 * (JPA-8032): `?embeddable=true` on the URL.
 *
 * Deliberately reads through `useQueryParams` (which re-parses `asPath`) rather than
 * `useRouter().query` directly: after any `setQueryParams` shallow push/replace, Next's own
 * `router.query` only reflects params matched by the route's dynamic segments (e.g. `marketSlug`)
 * — query-string-only keys like `embeddable` fall out of it, because `useQueryParams.setQueryParams`
 * pushes with a bare pathname template as `href` (no `query` object) and everything else baked into
 * the `as` string. `asPath` itself stays correct throughout, which is why `useQueryParams` re-parses
 * it instead of trusting `router.query` — this hook does the same for consistency.
 */
const useEmbeddable = (): boolean => {
  const [queryParams] = useQueryParams();
  return queryParams[EMBEDDABLE_QUERY_KEY] === 'true';
};

export default useEmbeddable;
